import React from 'react';
import { t } from '../i18n';
import { fmtDay, fmtMoney } from '../lib/format';

// What a technician is owed on one project, and exactly why.
//
//   what they quoted for their work
//   - supplies QPS bought and charged back to them
//   - what QPS has already paid them
//   = what's left for their labor
//
// The server sends only this shape to a vendor, so there is nothing here about
// what the homeowner was billed or what QPS made.
export default function TechSettlement({ settlement }) {
  if (!settlement) return null;
  const positive = settlement.balance >= 0;

  const Row = ({ label, value, color, strong }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid var(--border)' }}>
      <span style={{ fontSize: strong ? 14 : 13, color: strong ? 'var(--navy)' : 'var(--slate)' }}>{label}</span>
      <span style={{ fontSize: strong ? 16 : 14, color }}>{value}</span>
    </div>
  );

  return (
    <div className="lead-card" style={{ cursor: 'default' }}>
      <div style={{ fontSize: 15, marginBottom: 2 }}>{settlement.title}</div>
      {settlement.address && <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 10 }}>{settlement.address}</div>}

      {settlement.lines?.length > 0 && (
        <>
          <div className="sec-label">{t('pj.yourWork')}</div>
          {settlement.lines.map(l => (
            <div key={l._id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '3px 0' }}>
              <span>{l.trade}</span>
              <span>{fmtMoney(l.techCost)}</span>
            </div>
          ))}
        </>
      )}

      {settlement.supplies?.length > 0 && (
        <>
          <div className="sec-label" style={{ marginTop: 12 }}>{t('pj.suppliesCharged')}</div>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 6, lineHeight: 1.4 }}>{t('pj.suppliesNote')}</div>
          {settlement.supplies.map(s => (
            <div key={s._id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '3px 0' }}>
              <span style={{ color: 'var(--muted)', minWidth: 74 }}>{fmtDay(s.date)}</span>
              <span>{s.supplier}{s.description ? ` - ${s.description}` : ''}</span>
              <span style={{ marginLeft: 'auto', color: 'var(--red)' }}>-{fmtMoney(s.amount)}</span>
            </div>
          ))}
        </>
      )}

      <div style={{ marginTop: 14 }}>
        <Row label={t('pj.yourEstimateTotal')} value={fmtMoney(settlement.earned)} color="var(--navy)" />
        <Row label={t('pj.lessSupplies')} value={`-${fmtMoney(settlement.suppliesCharged)}`} color="var(--red)" />
        <Row label={t('pj.lessPaid')} value={`-${fmtMoney(settlement.paid)}`} color="var(--red)" />
        <Row
          label={positive ? t('pj.stillOwedToYou') : t('pj.overpaid')}
          value={fmtMoney(Math.abs(settlement.balance))}
          color={positive ? 'var(--green)' : 'var(--amber)'}
          strong
        />
      </div>
    </div>
  );
}
